import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import apiClient from '../api/client';
import { useLanguage } from '../context/LanguageContext';
import { getPasswordStrength, isStrongPassword } from '../utils/passwordValidation';
import './Auth.css';

function Register() {
  const navigate = useNavigate();
  const { language, t } = useLanguage();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    phone: '',
  });
  const [error, setError] = useState('');

  const passwordStrength = getPasswordStrength(formData.password);
  const isPasswordValid = isStrongPassword(formData.password);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!isStrongPassword(formData.password)) {
      setError(t('passwordRequirements'));
      return;
    }

    try {
      const res = await apiClient.post('/auth/register', { ...formData, preferred_language: language || 'lt' });
      localStorage.setItem('token', res.data.token);
      navigate('/');
      window.location.reload();
    } catch (err) {
      setError(err.response?.data?.error || t('registerError'));
    }
  };

  return (
    <div className="auth-page container">
      <div className="auth-card">
        <h1>{t('register')}</h1>
        
        {error && <div className="error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder={`${t('email')} *`}
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
            className="input"
          />
          <input
            type="password"
            placeholder={`${t('password')} *`}
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            required
            minLength={8}
            className="input"
          />
          {formData.password && (
            <div className="password-requirements" style={{ marginTop: 8, fontSize: 13, color: '#555' }}>
              <div style={{ marginBottom: 4, fontWeight: 600 }}>{t('passwordRequirements')}:</div>
              <div className={passwordStrength.hasMinLength ? 'req-met' : 'req-unmet'}>• {t('minChars')}</div>
              <div className={passwordStrength.hasUpperCase ? 'req-met' : 'req-unmet'}>• {t('oneUpperCase')}</div>
              <div className={passwordStrength.hasLowerCase ? 'req-met' : 'req-unmet'}>• {t('oneLowerCase')}</div>
              <div className={passwordStrength.hasNumber ? 'req-met' : 'req-unmet'}>• {t('oneNumber')}</div>
              <div className={passwordStrength.hasSymbol ? 'req-met' : 'req-unmet'}>• {t('oneSymbol')}</div>
            </div>
          )}
          <input
            type="text"
            placeholder={t('firstName')}
            value={formData.first_name}
            onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
            className="input"
          />
          <input
            type="text"
            placeholder={t('lastName')}
            value={formData.last_name}
            onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
            className="input"
          />
          <input
            type="tel"
            placeholder={t('phone')}
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            className="input"
          />
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!isPasswordValid}
          >
            {t('register')}
          </button>
        </form>

        <div className="auth-divider">
          <span className="divider-line"></span>
          <span className="divider-text">{t('or')}</span>
          <span className="divider-line"></span>
        </div>

        <Link to="/login" className="btn btn-secondary">
          {t('login')}
        </Link>
      </div>
    </div>
  );
}

export default Register;
